export const NUMBER_LABEL_ICON_POSITION_NONE = '';
export const NUMBER_LABEL_ICON_POSITION_LEFT = 'left';
export const NUMBER_LABEL_ICON_POSITION_RIGHT = 'right';
export const NUMBER_LABEL_ICON_POSITION = {
	NONE: NUMBER_LABEL_ICON_POSITION_NONE,
	LEFT: NUMBER_LABEL_ICON_POSITION_LEFT,
	RIGHT: NUMBER_LABEL_ICON_POSITION_RIGHT
};
